module.exports = __webpack_public_path__ + "img/12.99da1e5c.jpg";